var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoCustomer = function SvgIcoCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17.5,
    r: 15.4,
    fill: "#E9EAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M31.5 25.8c1.3 0 3-1.6 3-3V18c0-2.5-2.3-4.2-4.2-4.2h-4.2c-1.8 0-3.6 1.7-3.6 4.2v5.4c0 1.3.5 2.4 1.8 2.4v10.1h7.1V25.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.9 12.2c-1.6 0-3-1.3-3-3V8c0-1.7 1.4-3 3-3s3 1.3 3 3v1.2c0 1.7-1.4 3-3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 12.8c-2 0-3.6-1.6-3.6-3.6V8c0-2 1.6-3.6 3.6-3.6S31.5 6 31.5 8v1.2c0 2-1.6 3.6-3.6 3.6m0-7.2c-1.3 0-2.4 1.1-2.4 2.4v1.2c0 1.3 1.1 2.4 2.4 2.4s2.4-1.1 2.4-2.4V8c0-1.3-1.1-2.4-2.4-2.4M30.9 18.1h1.2v17.8h-1.2zM24.9 35.9h-1.2v-9.6c-.7-.1-1.7-.8-1.7-2.8v-1.8h1.2v1.8c0 1.8.9 1.8 1.2 1.8h.6v10.6zM27.3 25.8h1.2v10.1h-1.2zM22 19.3h5.9v1.2H22zM19.6 19.3h1.2v1.2h-1.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26 23.4-.9-.8 2.7-2.7-2.7-2.7.9-.8 3.5 3.5zM17.2 19.3h1.2v1.2h-1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 26.4v-1.2c1 0 2.4-1.4 2.4-2.4V18c0-2.2-2.1-3.6-3.6-3.6h-4.2c-1.5 0-3 1.3-3 3.6H22c0-3 2.1-4.8 4.2-4.8h4.2c2.2 0 4.8 2 4.8 4.8v4.8c-.2 1.7-2.1 3.6-3.7 3.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.388 30.036h-7.1v-5.9h7.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30.6h-8.3v-7.1H38zm-7.1-1.2h5.9v-4.8h-5.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.5 25.8c-1.2 0-3-1.6-3-3V18c0-2.5 2.3-4.2 4.2-4.2h4.2c1.8 0 3.6 1.7 3.6 4.2v5.4c0 1.3-.6 2.4-1.8 2.4v10.1H6.5zM10.1 12.2c1.6 0 3-1.3 3-3V8c0-1.7-1.4-3-3-3s-3 1.3-3 3v1.2c0 1.7 1.4 3 3 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 12.8c-2 0-3.6-1.6-3.6-3.6V8c0-2 1.6-3.6 3.6-3.6S13.7 6 13.7 8v1.2c0 2-1.6 3.6-3.6 3.6m0-7.2C8.8 5.6 7.7 6.7 7.7 8v1.2c0 1.3 1.1 2.4 2.4 2.4s2.4-1.1 2.4-2.4V8c0-1.3-1.1-2.4-2.4-2.4M5.9 18.1h1.2v17.8H5.9zM14.2 35.9H13V25.2h.6c1.1 0 1.2-1.4 1.2-1.8v-1.8H16v1.8c0 1.5-.7 2.6-1.8 2.9zM9.5 25.8h1.2v10.1H9.5zM10.1 19.3H16v1.2h-5.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m12 23.4-3.5-3.5 3.5-3.5.9.8-2.7 2.7 2.7 2.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 26.4c-1.7 0-3.6-1.9-3.6-3.6V18c0-2.7 2.5-4.8 4.8-4.8h4.2c2 0 4.2 1.8 4.2 4.8h-1.2c0-2.2-1.5-3.6-3-3.6H7.7c-1.5 0-3.6 1.4-3.6 3.6v4.8c0 1 1.4 2.4 2.4 2.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.6 24h7.1v5.9H.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 30.6H0v-7.1h8.3zm-7.1-1.2h5.9v-4.8H1.2z"
  })));
};
export default SvgIcoCustomer;